import type {
  TeaserBaseProps,
  TeaserHighlightProps,
  TeaserThemeProps,
} from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Content, Title } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'

interface TeaserRightNowProps extends TeaserBaseProps, TeaserThemeProps, TeaserHighlightProps {}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-right-now](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-right-now)
 * - Storybook: [TeaserRightNow](https://designsystem.dn.se/?path=/docs/section-teaserrightnow--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-right-now)/teaser-right-now.scss'`
 */

export const TeaserRightNow = ({
  title,
  targetLink,
  theme = 'nyheter',
  classNames,
  attributes,
  areaType,
}: TeaserRightNowProps) => {
  const componentClassName = 'ds-teaser'

  const classes = formatClassString(['ds-teaser--right-now', componentClassName, classNames])

  return (
    <TeaserCard areaType={areaType} targetLink={targetLink} theme={theme} classNames={classes} attributes={attributes}>
      <Content>
        <Title title={title} highlight={'Just nu:'} />
      </Content>
    </TeaserCard>
  )
}
